import { Link } from 'react-router-dom';
import { getTopRatedManhua } from '@/mocks/manhua';

export default function RankingSection() {
  const topManhua = getTopRatedManhua(8);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
            排行榜
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950">
            最火韩国漫画排行榜
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            根据阅读量、评分和热度综合排序，发现大家都在看的热门韩漫
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {topManhua.map((manhua, idx) => (
            <Link
              key={manhua.id}
              to={`/manhua/${manhua.slug}`}
              className="bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:scale-[1.02] transition-all duration-300 group relative"
            >
              <div className="absolute top-3 left-3 z-10 w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs font-bold">
                {idx + 1}
              </div>
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={manhua.cover}
                  alt={manhua.title}
                  title={`${manhua.title} - 韩漫网排行榜第${idx + 1}名`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">{manhua.title}</h3>
                <div className="flex items-center justify-between mt-1.5">
                  <div className="flex items-center gap-0.5">
                    <i className="ri-star-fill text-xs text-amber-500"></i>
                    <span className="text-xs font-medium text-foreground-600">{manhua.rating}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{manhua.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-200 text-sm"
          >
            查看完整排行榜 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}